import React from 'react';
import styles from './LinkToGoogleMap.styles';

interface Props {
  /**
   * Accepts either the legacy `"lat,lng"` string or the new
   * `{ latitude, longitude }` Location object from the API.
   */
  position: any;
  /** Optional text rendered in place of the raw coordinates. */
  label?: React.ReactNode;
}

const normalisePosition = (pos: any): string | undefined => {
  if (!pos) return undefined;
  if (typeof pos === 'string') return pos;
  if (typeof pos?.latitude === 'number' && typeof pos?.longitude === 'number') {
    return `${pos.latitude},${pos.longitude}`;
  }
  return undefined;
};

const LinkToGoogleMap: React.FC<Props> = ({ position, label }) => {
  const normalised = normalisePosition(position);
  if (!normalised) {
    return <span>-</span>;
  }

  return (
    <>
      <a
        href={`https://maps.google.com/?q=${normalised}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label ?? normalised}
      </a>
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToGoogleMap;
